/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { IconArrowNarrowLeft, IconArrowNarrowRight } from "@tabler/icons-react";

interface ArrowProps {
  direction: "left" | "right";
  onClick: () => void;
  disabled?: boolean;
}

const Arrow: React.FC<ArrowProps> = ({
  direction,
  onClick,
  disabled = false,
}) => (
  <div
    className={`flex items-center justify-center ${
      disabled ? "text-icon-disabled" : "cursor-pointer "
    }`}
    onClick={disabled ? undefined : onClick}
  >
    {direction === "left" ? (
      <IconArrowNarrowLeft />
    ) : (
      <IconArrowNarrowRight />
    )}
  </div>
);

export default Arrow;
